import React, { useState } from 'react';

import LoginModal from './loginModal';
import SignupModal from './signUpModal';

export type LoginSignupModalViewMode = 'login' | 'signup';

type Props = {
  initial?: LoginSignupModalViewMode;
};

/**
 * This provides a single modal that can be switched between Login and Signup flows
 */
const AuthenticationModal: React.FC<Props> = ({ initial = 'login' }) => {
  const [mode, setMode] = useState<LoginSignupModalViewMode>(
    initial ?? 'login'
  );

  if (mode === 'login') {
    return <LoginModal onCreateAccountClick={() => setMode('signup')} />;
  }
  return <SignupModal onLoginClick={() => setMode('login')} />;
};

export default AuthenticationModal;
